import FullPageLoading from './FullPageLoading';

export default FullPageLoading;



// WEBPACK FOOTER //
// ./src/client/Components/FullPageLoading/index.js